import React from 'react'

interface MiniLineChartProps {
  data?: number[]
  highlightIndex?: number
  className?: string
}

export const MiniLineChart: React.FC<MiniLineChartProps> = ({
  data = [36, 86, 40, 30, 78, 84, 66, 82, 88, 32, 52],
  highlightIndex,
  className,
}) => {
  const chartWidth = 185
  const left = 10
  const right = 10
  const width = chartWidth - left - right
  const bottomY = 124
  const chartHeight = 100
  const barWidth = 8
  const barHalfWidth = barWidth / 2
  const topNotchDepth = 4
  const dotRadius = 6
  const dotGap = 0
  const activeIndex = typeof highlightIndex === 'number' ? highlightIndex : data.length - 1

  const points = data.map((value, index) => {
    const x = left + (index / Math.max(1, data.length - 1)) * width
    const normalized = Math.max(0, Math.min(100, value))
    const y = bottomY - (normalized / 100) * chartHeight
    return { x, y }
  })

  return (
    <div className={`absolute right-0 top-0 h-[124px] w-[185px] overflow-hidden ${className || ''}`}>
      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 185 124" fill="none">
        {points.map((point, index) => (
          <path
            key={`bar-${index}`}
            d={[
              `M ${point.x - barHalfWidth} ${bottomY}`,
              `L ${point.x - barHalfWidth} ${Math.min(bottomY, point.y + dotRadius + dotGap)}`,
              `Q ${point.x} ${Math.min(bottomY, point.y + dotRadius + dotGap + topNotchDepth)} ${point.x + barHalfWidth} ${Math.min(bottomY, point.y + dotRadius + dotGap)}`,
              `L ${point.x + barHalfWidth} ${bottomY}`,
              'Z',
            ].join(' ')}
            fill="rgba(197,204,159,0.34)"
          />
        ))}

        {points.map((point, index) => (
          <circle
            key={`dot-${index}`}
            cx={point.x}
            cy={point.y}
            r={dotRadius}
            fill={index === activeIndex ? '#c8ed03' : 'rgba(197,204,159,0.85)'}
          />
        ))}
      </svg>
    </div>
  )
}

export default MiniLineChart
